// URLs
export var DEFAULT_APP_DOWNLOAD_LINK = "https://catch.onelink.me/N79h/DownloadAppFooter";
export var URL_CATCH_LOGO_SEO = "https://s.catch.com.au/static/catch/images/catch-logo-e7014ee2c7.png";
export var URL_CATCH_HELP_CENTER = "https://help.catch.com.au/s/"; // schedule entry

export var SCHEDULE_ENTRY_STYLE_SMALL = "small";